var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { apiClient } from '@utils/apiClient';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';
export const machineService = {
    getAll(businessId) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = businessId ? `/machines?businessId=${businessId}` : '/machines';
            return apiClient.get(url);
        });
    },
    getByBusinessId(businessId) {
        return __awaiter(this, void 0, void 0, function* () {
            return apiClient.get(`/businesses/${businessId}/machines`);
        });
    },
    getById(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return apiClient.get(`/machines/${id}`);
        });
    },
    create(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return apiClient.post('/machines', data);
        });
    },
    update(id, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return apiClient.put(`/machines/${id}`, data);
        });
    },
    delete(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return apiClient.delete(`/machines/${id}`);
        });
    },
    exportToExcel(businessId) {
        return __awaiter(this, void 0, void 0, function* () {
            const token = localStorage.getItem('token');
            const url = businessId
                ? `${API_BASE_URL}/machines/export?businessId=${businessId}`
                : `${API_BASE_URL}/machines/export`;
            const response = yield fetch(url, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (!response.ok) {
                throw new Error('Failed to export machines');
            }
            return response.blob();
        });
    },
    exportMachineDetails(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const token = localStorage.getItem('token');
            const url = `${API_BASE_URL}/machines/${id}/export`;
            const response = yield fetch(url, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            if (!response.ok) {
                throw new Error('Failed to export machine details');
            }
            return response.blob();
        });
    },
};
